import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-2xl border border-gray-200 p-5" }
const _hoisted_2 = { class: "text-sm font-bold text-gray-900" }
const _hoisted_3 = { class: "mt-2 space-y-1.5 text-sm text-gray-800" }

import { computed } from 'vue'
import { RouterLink } from 'vue-router'


export default {
  __name: 'MarketingAgentSaw',
  props: {
  title: { type: String, default: 'The agent saw' },
  signals: { type: Object, default: () => ({}) },
  warnings: { type: Array, default: () => [] }
},
  setup(__props) {

const props = __props
const fired = computed(() =>
  Object.entries(props.signals || {})
    .filter(([, s]) => s?.fired)
    .map(([key, s]) => ({ key, evidence: s.evidence }))
)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fired.value, (s) => {
        return (_openBlock(), _createElementBlock("li", {
          key: s.key,
          class: "flex gap-2"
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("span", {
            class: "text-green-600 font-bold",
            "aria-hidden": "true"
          }, "+", -1)),
          _createElementVNode("span", null, _toDisplayString(s.evidence), 1)
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.warnings, (w, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: `w${i}`,
          "data-warning": "",
          class: "flex gap-2"
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("span", {
            class: "text-amber-600 font-bold",
            "aria-hidden": "true"
          }, "!", -1)),
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(w.text) + " ", 1),
            (w.link)
              ? (_openBlock(), _createBlock(_unref(RouterLink), {
                  key: 0,
                  to: w.link,
                  class: "underline"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("Fix it", -1)
                  ]))]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

}